import useAuth from "../../../../context/auth"
import { Share } from "./components/share"
import { usePageTitle } from "../../../../hooks"
import { Rewards } from "./components/rewards"
import { DefaultedContracts } from "./components/defaultedContracts"
import { Extract } from "./components/extract"

export const IndicationTab = () => {
    usePageTitle("Indique e ganhe")
    const { user, indicationTab } = useAuth()

    return (
        <>
            {indicationTab === "share" && <Share />}
            {indicationTab === "rewards" && <Rewards />}
            {indicationTab === "defaulted_contracts" && <DefaultedContracts />}
            {indicationTab === "extract" && <Extract />}
        </>
    )
}